module.exports = __webpack_public_path__ + "static/media/sandwich-image-3.e1aebc0b.png";